import { render, staticRenderFns } from "./logout-floatRight.vue?vue&type=template&id=3020d154&"
import script from "./logout-floatRight.vue?vue&type=script&lang=js&"
export * from "./logout-floatRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports